import { render } from "./Scrap_button.vue?vue&type=template&id=4c3524ae&scoped=true"
import script from "./Scrap_button.vue?vue&type=script&lang=js"
export * from "./Scrap_button.vue?vue&type=script&lang=js"

import "./Scrap_button.vue?vue&type=style&index=0&id=4c3524ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3524ae"]])

export default __exports__